import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/esm/slicedToArray';
import _pt from 'prop-types';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import { useRef, useLayoutEffect, useState, useCallback, useEffect } from 'react';
import isObject from 'lodash/isObject';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import { useMutationObserver } from '@commercetools-uikit/hooks';
import _Object$fromEntries from '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import kebabCase from 'lodash/kebabCase';
import { jsx } from '@emotion/react/jsx-runtime';
import { css } from '@emotion/react';

/*
  THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
  This file is created by the 'scripts/generate-design-tokens.js' script.
  The variables should be updated in 'materials/internals/definition.yaml'.
*/
const themes = {
  default: {
    colorPrimary: 'hsl(240, 64%, 58%)',
    colorPrimary10: 'hsl(240, 66%, 19%)',
    colorPrimary20: 'hsl(240, 45%, 33%)',
    colorPrimary25: 'hsl(240, 46%, 48%)',
    colorPrimary30: 'hsl(240, 46%, 53%)',
    colorPrimary40: 'hsl(240, 100%, 67%)',
    colorPrimary85: 'hsl(244, 100%, 84%)',
    colorPrimary90: 'hsl(243, 100%, 93%)',
    colorPrimary95: 'hsl(244, 100%, 97%)',
    colorPrimary98: 'hsl(244, 100%, 99%)',
    colorAccent: '#213c45',
    colorAccent10: 'hsl(195, 100%, 10%)',
    colorAccent20: 'hsl(195, 80%, 20%)',
    colorAccent30: 'hsl(195, 70%, 30%)',
    colorAccent40: 'hsl(195, 70%, 40%)',
    colorAccent50: 'hsl(195, 70%, 50%)',
    colorAccent60: 'hsl(195, 70%, 60%)',
    colorAccent85: 'hsl(195, 85%, 85%)',
    colorAccent90: 'hsl(195, 90%, 90%)',
    colorAccent95: 'hsl(195, 95%, 95%)',
    colorAccent98: 'hsl(195, 100%, 98%)',
    colorBrown10: 'hsl(41, 100%, 10%)',
    colorBrown20: 'hsl(41, 100%, 20%)',
    colorBrown35: 'hsl(41, 96%, 35%)',
    colorBrown50: 'hsl(41, 95%, 44%)',
    colorBrown70: 'hsl(47, 95%, 70%)',
    colorBrown85: 'hsl(47, 100%, 85%)',
    colorBrown90: 'hsl(47, 100%, 90%)',
    colorBrown95: 'hsl(47, 100%, 95%)',
    colorBrown98: 'hsl(48, 100%, 97%)',
    colorPurple10: 'hsl(248, 88%, 10%)',
    colorPurple20: 'hsl(248, 50%, 20%)',
    colorPurple35: 'hsl(248, 25%, 35%)',
    colorPurple50: 'hsl(248, 64%, 58%)',
    colorPurple70: 'hsl(248, 80%, 70%)',
    colorPurple85: 'hsl(249, 100%, 85%)',
    colorPurple90: 'hsl(248, 100%, 90%)',
    colorPurple95: 'hsl(248, 100%, 95%)',
    colorPurple98: 'hsl(246, 100%, 98%)',
    colorTurquoise10: 'hsl(180, 88%, 10%)',
    colorTurquoise20: 'hsl(180, 90%, 20%)',
    colorTurquoise35: 'hsl(178, 88%, 35%)',
    colorTurquoise50: 'hsl(178, 67%, 50%)',
    colorTurquoise70: 'hsl(180, 75%, 70%)',
    colorTurquoise85: 'hsl(180, 90%, 85%)',
    colorTurquoise90: 'hsl(180, 88%, 90%)',
    colorTurquoise95: 'hsl(180, 88%, 95%)',
    colorTurquoise98: 'hsl(180, 100%, 98%)',
    colorNeutral: 'hsl(232, 18%, 80%)',
    colorNeutral05: 'hsl(0deg 0% 80% / 5%)',
    colorNeutral10: 'hsl(0deg 0% 80% / 10%)',
    colorNeutral40: 'hsl(232, 18%, 40%)',
    colorNeutral50: 'hsl(233, 18%, 50%)',
    colorNeutral60: 'hsl(232, 18%, 60%)',
    colorNeutral85: 'hsl(232, 18%, 85%)',
    colorNeutral90: 'hsl(232, 18%, 90%)',
    colorNeutral95: 'hsl(232, 18%, 95%)',
    colorNeutral98: 'hsl(232, 18%, 98%)',
    colorInfo: '#078cdf',
    colorInfo40: 'hsl(203.05555555555554, 93.9130434783%, 40%)',
    colorInfo50: 'hsl(203.05555555555554, 93.9130434783%, 50%)',
    colorInfo60: 'hsl(203.05555555555554, 93.9130434783%, 60%)',
    colorInfo85: 'hsl(203.05555555555554, 93.9130434783%, 85%)',
    colorInfo90: '#CEEBFD',
    colorInfo95: 'hsl(203.05555555555554, 93.9130434783%, 95%)',
    colorWarning: 'hsl(35, 90%, 45%)',
    colorWarning25: 'hsl(33, 83%, 25%)',
    colorWarning40: 'hsl(33, 80%, 34%)',
    colorWarning60: 'hsl(35, 90%, 55%)',
    colorWarning85: 'hsl(33, 90%, 80%)',
    colorWarning95: 'hsl(45, 100%, 92%)',
    colorError: 'hsl(3, 65%, 58%)',
    colorError25: 'hsl(4, 69%, 37%)',
    colorError40: 'hsl(3, 60%, 46%)',
    colorError85: 'hsl(1, 55%, 74%)',
    colorError95: 'hsl(349, 66%, 92%)',
    colorSolid: '#1a1a1a',
    colorSolid02: 'hsl(0deg 0% 10% / 2%)',
    colorSolid05: 'hsl(0deg 0% 10% / 5%)',
    colorSolid10: 'hsl(0deg 0% 10% / 10%)',
    colorSurface: '#fff',
    colorTransparent: 'transparent',
    colorSuccess: 'hsl(152, 77%, 39%)',
    colorSuccess25: 'hsl(155, 84%, 20%)',
    colorSuccess40: 'hsl(155, 90%, 24%)',
    colorSuccess85: 'hsl(144, 69%, 80%)',
    colorSuccess95: 'hsl(141, 76%, 92%)',
    borderRadius1: '1px',
    borderRadius2: '2px',
    borderRadius4: '4px',
    borderRadius6: '6px',
    borderRadius8: '8px',
    borderRadius20: '20px',
    borderWidth1: '1px',
    borderWidth2: '2px',
    fontFamily: "'Inter', system-ui",
    fontSize10: '0.75rem',
    fontSize12: '0.8rem',
    fontSize20: '0.875rem',
    fontSize30: '1rem',
    fontSize40: '1.125rem',
    fontSize50: '1.25rem',
    fontSize60: '1.5rem',
    fontSize70: '2rem',
    fontSize80: '2.5rem',
    fontSize90: '3rem',
    fontSize15: '0.9231rem',
    fontSize35: '1.0769rem',
    fontSize45: '1.2308rem',
    fontSize63: '1.5385rem',
    fontSize66: '1.8462rem',
    fontSize69: '2.4615rem',
    fontSize78: '3rem',
    fontWeight300: '300',
    fontWeight400: '400',
    fontWeight500: '500',
    fontWeight600: '600',
    fontWeight700: '700',
    lineHeight05: '1.125rem',
    lineHeight10: '1.25rem',
    lineHeight18: '1.3rem',
    lineHeight20: '1.375rem',
    lineHeight30: '1.5rem',
    lineHeight40: '1.625rem',
    lineHeight50: '1.75rem',
    lineHeight60: '2.125rem',
    shadow0: 'none',
    shadow1: '0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24)',
    shadow2: '0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)',
    shadow3: '0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)',
    shadow4: '0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)',
    shadow5: '0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22)',
    shadow6: '0 -1px 2px 0 rgba(0, 0, 0, 0.2)',
    shadow7: '0 -1px 1.5px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.24)',
    shadow8: '0 1px 9.5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.24)',
    shadow9: 'inset 0 -1px 3px 0 rgba(0, 0, 0, 0.1), inset 0 1px 1.5px 0 rgba(0, 0, 0, 0.2), inset 0 1px 1.5px 0 rgba(0, 0, 0, 0.25)',
    shadow10: '0 0 0 1px rgba(224, 230, 237, 0.5)',
    shadow11: '0 1px 0.5px rgba(0, 0, 0, 0.24), 0 -1px 0.75px rgba(0, 0, 0, 0.12)',
    shadow12: '0 0 1px rgba(0, 0, 0, 0.25)',
    shadow13: '0 0 1px rgba(0, 0, 0, 0.25)',
    shadow14: '0 0 0.5px rgba(0, 0, 0, 0.1)',
    shadow15: '0 2px 2px rgba(0, 0, 0, 0.24), 0 1px 4.75px rgba(0, 0, 0, 0.12)',
    shadow16: '0.5px 1.5px 4px 1px rgba(0, 0, 0, 0.25), -0.5px -0.5px 4px 1px rgba(0, 0, 0, 0.25)',
    shadow17: '0 1px 5px 0 rgba(0, 0, 0, 0.05)',
    shadow18: '0 5px 30px 0px rgba(0, 0, 0, 0.1)',
    constraintScale: '100%',
    constraint1: '42px',
    constraint2: '84px',
    constraint3: '142px',
    constraint4: '184px',
    constraint5: '242px',
    constraint6: '284px',
    constraint7: '342px',
    constraint8: '384px',
    constraint9: '442px',
    constraint10: '484px',
    constraint11: '542px',
    constraint12: '584px',
    constraint13: '642px',
    constraint14: '684px',
    constraint15: '742px',
    constraint16: '784px',
    spacingXs: '4px',
    spacingS: '8px',
    spacingM: '16px',
    spacingL: '24px',
    spacingXl: '32px',
    spacing05: '2px',
    spacing10: '4px',
    spacing20: '8px',
    spacing25: '12px',
    spacing30: '16px',
    spacing40: '24px',
    spacing50: '32px',
    spacing55: '40px',
    spacing60: '48px',
    spacing70: '64px',
    transitionLinear80Ms: '80ms linear',
    transitionEaseinout150Ms: '150ms ease-in-out',
    transitionStandard: '200ms ease',
    breakPointMobile: '768px',
    breakPointDesktop: '1024px',
    breakPointBiggerdesktop: '1280px',
    breakPointGiantdesktop: '1680px',
    breakPointJumbodesktop: '1920px',
    backgroundColorForInput: '#fff',
    backgroundColorForInputWhenDisabled: 'hsl(232, 18%, 95%)',
    backgroundColorForInputWhenReadonly: 'hsl(232, 18%, 95%)',
    backgroundColorForInputWhenHovered: 'hsl(244, 100%, 99%)',
    backgroundColorForLocalizedInputLabel: '#fff',
    backgroundColorForLocalizedInputLabelWhenReadonly: 'hsl(232, 18%, 95%)',
    backgroundColorForLocalizedInputLabelWhenDisabled: 'hsl(232, 18%, 95%)',
    backgroundColorForButtonWhenActive: 'hsl(243, 100%, 93%)',
    backgroundColorForButtonWhenHovered: 'hsl(244, 100%, 97%)',
    backgroundColorForButtonWhenDisabled: 'hsl(232, 18%, 95%)',
    borderColorForInput: 'hsl(232, 18%, 80%)',
    borderColorForInputWhenDisabled: 'hsl(232, 18%, 80%)',
    borderColorForInputWhenReadonly: '#fff',
    borderColorForInputWhenError: 'hsl(3, 65%, 58%)',
    borderColorForInputWhenWarning: 'hsl(35, 90%, 45%)',
    borderColorForInputWhenHovered: 'hsl(232, 18%, 80%)',
    borderColorForInputWhenFocused: 'hsl(240, 100%, 67%)',
    borderColorForButtonAsSecondary: 'hsl(244, 100%, 84%)',
    borderRadiusForInput: '4px',
    fontColorForInput: '#1a1a1a',
    fontColorForInputWhenDisabled: 'hsl(232, 18%, 60%)',
    fontColorForInputWhenError: 'hsl(3, 60%, 46%)',
    fontColorForInputWhenReadonly: 'hsl(232, 18%, 40%)',
    fontColorForInputWhenWarning: 'hsl(35, 90%, 45%)',
    fontColorForButtonAsSecondary: 'hsl(240, 64%, 58%)',
    heightForButtonAsBig: '40px',
    heightForButtonAsSmall: '16px',
    heightForButtonAsMedium: '32px',
    heightForButtonAs40: '40px',
    heightForButtonAs30: '32px',
    heightForButtonAs20: '24px',
    heightForButtonAs10: '16px',
    heightForInput: '40px',
    heightForInputAsSmall: '32px',
    shadowForInput: 'none',
    shadowForInputWhenFocused: 'inset 0 0 0 1px var(--color-primary)',
    shadowForInputWhenError: 'inset 0 0 0 1px var(--color-error)',
    shadowForInputWhenWarning: 'inset 0 0 0 1px var(--color-warning)'
  }
};
const designTokens = {
  colorPrimary: 'var(--color-primary, hsl(240, 64%, 58%))',
  colorPrimary10: 'var(--color-primary-10, hsl(240, 66%, 19%))',
  colorPrimary20: 'var(--color-primary-20, hsl(240, 45%, 33%))',
  colorPrimary25: 'var(--color-primary-25, hsl(240, 46%, 48%))',
  colorPrimary30: 'var(--color-primary-30, hsl(240, 46%, 53%))',
  colorPrimary40: 'var(--color-primary-40, hsl(240, 100%, 67%))',
  colorPrimary85: 'var(--color-primary-85, hsl(244, 100%, 84%))',
  colorPrimary90: 'var(--color-primary-90, hsl(243, 100%, 93%))',
  colorPrimary95: 'var(--color-primary-95, hsl(244, 100%, 97%))',
  colorPrimary98: 'var(--color-primary-98, hsl(244, 100%, 99%))',
  colorAccent: 'var(--color-accent, #213c45)',
  colorAccent10: 'var(--color-accent-10, hsl(195, 100%, 10%))',
  colorAccent20: 'var(--color-accent-20, hsl(195, 80%, 20%))',
  colorAccent30: 'var(--color-accent-30, hsl(195, 70%, 30%))',
  colorAccent40: 'var(--color-accent-40, hsl(195, 70%, 40%))',
  colorAccent50: 'var(--color-accent-50, hsl(195, 70%, 50%))',
  colorAccent60: 'var(--color-accent-60, hsl(195, 70%, 60%))',
  colorAccent85: 'var(--color-accent-85, hsl(195, 85%, 85%))',
  colorAccent90: 'var(--color-accent-90, hsl(195, 90%, 90%))',
  colorAccent95: 'var(--color-accent-95, hsl(195, 95%, 95%))',
  colorAccent98: 'var(--color-accent-98, hsl(195, 100%, 98%))',
  colorBrown10: 'var(--color-brown-10, hsl(41, 100%, 10%))',
  colorBrown20: 'var(--color-brown-20, hsl(41, 100%, 20%))',
  colorBrown35: 'var(--color-brown-35, hsl(41, 96%, 35%))',
  colorBrown50: 'var(--color-brown-50, hsl(41, 95%, 44%))',
  colorBrown70: 'var(--color-brown-70, hsl(47, 95%, 70%))',
  colorBrown85: 'var(--color-brown-85, hsl(47, 100%, 85%))',
  colorBrown90: 'var(--color-brown-90, hsl(47, 100%, 90%))',
  colorBrown95: 'var(--color-brown-95, hsl(47, 100%, 95%))',
  colorBrown98: 'var(--color-brown-98, hsl(48, 100%, 97%))',
  colorPurple10: 'var(--color-purple-10, hsl(248, 88%, 10%))',
  colorPurple20: 'var(--color-purple-20, hsl(248, 50%, 20%))',
  colorPurple35: 'var(--color-purple-35, hsl(248, 25%, 35%))',
  colorPurple50: 'var(--color-purple-50, hsl(248, 64%, 58%))',
  colorPurple70: 'var(--color-purple-70, hsl(248, 80%, 70%))',
  colorPurple85: 'var(--color-purple-85, hsl(249, 100%, 85%))',
  colorPurple90: 'var(--color-purple-90, hsl(248, 100%, 90%))',
  colorPurple95: 'var(--color-purple-95, hsl(248, 100%, 95%))',
  colorPurple98: 'var(--color-purple-98, hsl(246, 100%, 98%))',
  colorTurquoise10: 'var(--color-turquoise-10, hsl(180, 88%, 10%))',
  colorTurquoise20: 'var(--color-turquoise-20, hsl(180, 90%, 20%))',
  colorTurquoise35: 'var(--color-turquoise-35, hsl(178, 88%, 35%))',
  colorTurquoise50: 'var(--color-turquoise-50, hsl(178, 67%, 50%))',
  colorTurquoise70: 'var(--color-turquoise-70, hsl(180, 75%, 70%))',
  colorTurquoise85: 'var(--color-turquoise-85, hsl(180, 90%, 85%))',
  colorTurquoise90: 'var(--color-turquoise-90, hsl(180, 88%, 90%))',
  colorTurquoise95: 'var(--color-turquoise-95, hsl(180, 88%, 95%))',
  colorTurquoise98: 'var(--color-turquoise-98, hsl(180, 100%, 98%))',
  colorNeutral: 'var(--color-neutral, hsl(232, 18%, 80%))',
  colorNeutral05: 'var(--color-neutral-05, hsl(0deg 0% 80% / 5%))',
  colorNeutral10: 'var(--color-neutral-10, hsl(0deg 0% 80% / 10%))',
  colorNeutral40: 'var(--color-neutral-40, hsl(232, 18%, 40%))',
  colorNeutral50: 'var(--color-neutral-50, hsl(233, 18%, 50%))',
  colorNeutral60: 'var(--color-neutral-60, hsl(232, 18%, 60%))',
  colorNeutral85: 'var(--color-neutral-85, hsl(232, 18%, 85%))',
  colorNeutral90: 'var(--color-neutral-90, hsl(232, 18%, 90%))',
  colorNeutral95: 'var(--color-neutral-95, hsl(232, 18%, 95%))',
  colorNeutral98: 'var(--color-neutral-98, hsl(232, 18%, 98%))',
  colorInfo: 'var(--color-info, #078cdf)',
  colorInfo40: 'var(--color-info-40, hsl(203.05555555555554, 93.9130434783%, 40%))',
  colorInfo50: 'var(--color-info-50, hsl(203.05555555555554, 93.9130434783%, 50%))',
  colorInfo60: 'var(--color-info-60, hsl(203.05555555555554, 93.9130434783%, 60%))',
  colorInfo85: 'var(--color-info-85, hsl(203.05555555555554, 93.9130434783%, 85%))',
  colorInfo90: 'var(--color-info-90, #CEEBFD)',
  colorInfo95: 'var(--color-info-95, hsl(203.05555555555554, 93.9130434783%, 95%))',
  colorWarning: 'var(--color-warning, hsl(35, 90%, 45%))',
  colorWarning25: 'var(--color-warning-25, hsl(33, 83%, 25%))',
  colorWarning40: 'var(--color-warning-40, hsl(33, 80%, 34%))',
  colorWarning60: 'var(--color-warning-60, hsl(35, 90%, 55%))',
  colorWarning85: 'var(--color-warning-85, hsl(33, 90%, 80%))',
  colorWarning95: 'var(--color-warning-95, hsl(45, 100%, 92%))',
  colorError: 'var(--color-error, hsl(3, 65%, 58%))',
  colorError25: 'var(--color-error-25, hsl(4, 69%, 37%))',
  colorError40: 'var(--color-error-40, hsl(3, 60%, 46%))',
  colorError85: 'var(--color-error-85, hsl(1, 55%, 74%))',
  colorError95: 'var(--color-error-95, hsl(349, 66%, 92%))',
  colorSolid: 'var(--color-solid, #1a1a1a)',
  colorSolid02: 'var(--color-solid-02, hsl(0deg 0% 10% / 2%))',
  colorSolid05: 'var(--color-solid-05, hsl(0deg 0% 10% / 5%))',
  colorSolid10: 'var(--color-solid-10, hsl(0deg 0% 10% / 10%))',
  colorSurface: 'var(--color-surface, #fff)',
  colorTransparent: 'var(--color-transparent, transparent)',
  colorSuccess: 'var(--color-success, hsl(152, 77%, 39%))',
  colorSuccess25: 'var(--color-success-25, hsl(155, 84%, 20%))',
  colorSuccess40: 'var(--color-success-40, hsl(155, 90%, 24%))',
  colorSuccess85: 'var(--color-success-85, hsl(144, 69%, 80%))',
  colorSuccess95: 'var(--color-success-95, hsl(141, 76%, 92%))',
  borderRadius1: 'var(--border-radius-1, 1px)',
  borderRadius2: 'var(--border-radius-2, 2px)',
  borderRadius4: 'var(--border-radius-4, 4px)',
  borderRadius6: 'var(--border-radius-6, 6px)',
  borderRadius8: 'var(--border-radius-8, 8px)',
  borderRadius20: 'var(--border-radius-20, 20px)',
  borderWidth1: 'var(--border-width-1, 1px)',
  borderWidth2: 'var(--border-width-2, 2px)',
  fontFamily: "var(--font-family, 'Inter', system-ui)",
  fontSize10: 'var(--font-size-10, 0.75rem)',
  fontSize12: 'var(--font-size-12, 0.8rem)',
  fontSize20: 'var(--font-size-20, 0.875rem)',
  fontSize30: 'var(--font-size-30, 1rem)',
  fontSize40: 'var(--font-size-40, 1.125rem)',
  fontSize50: 'var(--font-size-50, 1.25rem)',
  fontSize60: 'var(--font-size-60, 1.5rem)',
  fontSize70: 'var(--font-size-70, 2rem)',
  fontSize80: 'var(--font-size-80, 2.5rem)',
  fontSize90: 'var(--font-size-90, 3rem)',
  fontSize15: 'var(--font-size-15, 0.9231rem)',
  fontSize35: 'var(--font-size-35, 1.0769rem)',
  fontSize45: 'var(--font-size-45, 1.2308rem)',
  fontSize63: 'var(--font-size-63, 1.5385rem)',
  fontSize66: 'var(--font-size-66, 1.8462rem)',
  fontSize69: 'var(--font-size-69, 2.4615rem)',
  fontSize78: 'var(--font-size-78, 3rem)',
  fontWeight300: 'var(--font-weight-300, 300)',
  fontWeight400: 'var(--font-weight-400, 400)',
  fontWeight500: 'var(--font-weight-500, 500)',
  fontWeight600: 'var(--font-weight-600, 600)',
  fontWeight700: 'var(--font-weight-700, 700)',
  lineHeight05: 'var(--line-height-05, 1.125rem)',
  lineHeight10: 'var(--line-height-10, 1.25rem)',
  lineHeight18: 'var(--line-height-18, 1.3rem)',
  lineHeight20: 'var(--line-height-20, 1.375rem)',
  lineHeight30: 'var(--line-height-30, 1.5rem)',
  lineHeight40: 'var(--line-height-40, 1.625rem)',
  lineHeight50: 'var(--line-height-50, 1.75rem)',
  lineHeight60: 'var(--line-height-60, 2.125rem)',
  shadow0: 'var(--shadow-0, none)',
  shadow1: 'var(--shadow-1, 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24))',
  shadow2: 'var(--shadow-2, 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23))',
  shadow3: 'var(--shadow-3, 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23))',
  shadow4: 'var(--shadow-4, 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22))',
  shadow5: 'var(--shadow-5, 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22))',
  shadow6: 'var(--shadow-6, 0 -1px 2px 0 rgba(0, 0, 0, 0.2))',
  shadow7: 'var(--shadow-7, 0 -1px 1.5px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.24))',
  shadow8: 'var(--shadow-8, 0 1px 9.5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.24))',
  shadow9: 'var(--shadow-9, inset 0 -1px 3px 0 rgba(0, 0, 0, 0.1), inset 0 1px 1.5px 0 rgba(0, 0, 0, 0.2), inset 0 1px 1.5px 0 rgba(0, 0, 0, 0.25))',
  shadow10: 'var(--shadow-10, 0 0 0 1px rgba(224, 230, 237, 0.5))',
  shadow11: 'var(--shadow-11, 0 1px 0.5px rgba(0, 0, 0, 0.24), 0 -1px 0.75px rgba(0, 0, 0, 0.12))',
  shadow12: 'var(--shadow-12, 0 0 1px rgba(0, 0, 0, 0.25))',
  shadow13: 'var(--shadow-13, 0 0 1px rgba(0, 0, 0, 0.25))',
  shadow14: 'var(--shadow-14, 0 0 0.5px rgba(0, 0, 0, 0.1))',
  shadow15: 'var(--shadow-15, 0 2px 2px rgba(0, 0, 0, 0.24), 0 1px 4.75px rgba(0, 0, 0, 0.12))',
  shadow16: 'var(--shadow-16, 0.5px 1.5px 4px 1px rgba(0, 0, 0, 0.25), -0.5px -0.5px 4px 1px rgba(0, 0, 0, 0.25))',
  shadow17: 'var(--shadow-17, 0 1px 5px 0 rgba(0, 0, 0, 0.05))',
  shadow18: 'var(--shadow-18, 0 5px 30px 0px rgba(0, 0, 0, 0.1))',
  constraintScale: 'var(--constraint-scale, 100%)',
  constraint1: 'var(--constraint-1, 42px)',
  constraint2: 'var(--constraint-2, 84px)',
  constraint3: 'var(--constraint-3, 142px)',
  constraint4: 'var(--constraint-4, 184px)',
  constraint5: 'var(--constraint-5, 242px)',
  constraint6: 'var(--constraint-6, 284px)',
  constraint7: 'var(--constraint-7, 342px)',
  constraint8: 'var(--constraint-8, 384px)',
  constraint9: 'var(--constraint-9, 442px)',
  constraint10: 'var(--constraint-10, 484px)',
  constraint11: 'var(--constraint-11, 542px)',
  constraint12: 'var(--constraint-12, 584px)',
  constraint13: 'var(--constraint-13, 642px)',
  constraint14: 'var(--constraint-14, 684px)',
  constraint15: 'var(--constraint-15, 742px)',
  constraint16: 'var(--constraint-16, 784px)',
  spacingXs: 'var(--spacing-xs, 4px)',
  spacingS: 'var(--spacing-s, 8px)',
  spacingM: 'var(--spacing-m, 16px)',
  spacingL: 'var(--spacing-l, 24px)',
  spacingXl: 'var(--spacing-xl, 32px)',
  spacing05: 'var(--spacing-05, 2px)',
  spacing10: 'var(--spacing-10, 4px)',
  spacing20: 'var(--spacing-20, 8px)',
  spacing25: 'var(--spacing-25, 12px)',
  spacing30: 'var(--spacing-30, 16px)',
  spacing40: 'var(--spacing-40, 24px)',
  spacing50: 'var(--spacing-50, 32px)',
  spacing55: 'var(--spacing-55, 40px)',
  spacing60: 'var(--spacing-60, 48px)',
  spacing70: 'var(--spacing-70, 64px)',
  transitionLinear80Ms: 'var(--transition-linear-80-ms, 80ms linear)',
  transitionEaseinout150Ms: 'var(--transition-easeinout-150-ms, 150ms ease-in-out)',
  transitionStandard: 'var(--transition-standard, 200ms ease)',
  breakPointMobile: 'var(--break-point-mobile, 768px)',
  breakPointDesktop: 'var(--break-point-desktop, 1024px)',
  breakPointBiggerdesktop: 'var(--break-point-biggerdesktop, 1280px)',
  breakPointGiantdesktop: 'var(--break-point-giantdesktop, 1680px)',
  breakPointJumbodesktop: 'var(--break-point-jumbodesktop, 1920px)',
  backgroundColorForInput: 'var(--background-color-for-input, #fff)',
  backgroundColorForInputWhenDisabled: 'var(--background-color-for-input-when-disabled, hsl(232, 18%, 95%))',
  backgroundColorForInputWhenReadonly: 'var(--background-color-for-input-when-readonly, hsl(232, 18%, 95%))',
  backgroundColorForInputWhenHovered: 'var(--background-color-for-input-when-hovered, hsl(244, 100%, 99%))',
  backgroundColorForLocalizedInputLabel: 'var(--background-color-for-localized-input-label, #fff)',
  backgroundColorForLocalizedInputLabelWhenReadonly: 'var(--background-color-for-localized-input-label-when-readonly, hsl(232, 18%, 95%))',
  backgroundColorForLocalizedInputLabelWhenDisabled: 'var(--background-color-for-localized-input-label-when-disabled, hsl(232, 18%, 95%))',
  backgroundColorForButtonWhenActive: 'var(--background-color-for-button-when-active, hsl(243, 100%, 93%))',
  backgroundColorForButtonWhenHovered: 'var(--background-color-for-button-when-hovered, hsl(244, 100%, 97%))',
  backgroundColorForButtonWhenDisabled: 'var(--background-color-for-button-when-disabled, hsl(232, 18%, 95%))',
  borderColorForInput: 'var(--border-color-for-input, hsl(232, 18%, 80%))',
  borderColorForInputWhenDisabled: 'var(--border-color-for-input-when-disabled, hsl(232, 18%, 80%))',
  borderColorForInputWhenReadonly: 'var(--border-color-for-input-when-readonly, #fff)',
  borderColorForInputWhenError: 'var(--border-color-for-input-when-error, hsl(3, 65%, 58%))',
  borderColorForInputWhenWarning: 'var(--border-color-for-input-when-warning, hsl(35, 90%, 45%))',
  borderColorForInputWhenHovered: 'var(--border-color-for-input-when-hovered, hsl(232, 18%, 80%))',
  borderColorForInputWhenFocused: 'var(--border-color-for-input-when-focused, hsl(240, 100%, 67%))',
  borderColorForButtonAsSecondary: 'var(--border-color-for-button-as-secondary, hsl(244, 100%, 84%))',
  borderRadiusForInput: 'var(--border-radius-for-input, 4px)',
  fontColorForInput: 'var(--font-color-for-input, #1a1a1a)',
  fontColorForInputWhenDisabled: 'var(--font-color-for-input-when-disabled, hsl(232, 18%, 60%))',
  fontColorForInputWhenError: 'var(--font-color-for-input-when-error, hsl(3, 60%, 46%))',
  fontColorForInputWhenReadonly: 'var(--font-color-for-input-when-readonly, hsl(232, 18%, 40%))',
  fontColorForInputWhenWarning: 'var(--font-color-for-input-when-warning, hsl(35, 90%, 45%))',
  fontColorForButtonAsSecondary: 'var(--font-color-for-button-as-secondary, hsl(240, 64%, 58%))',
  heightForButtonAsBig: 'var(--height-for-button-as-big, 40px)',
  heightForButtonAsSmall: 'var(--height-for-button-as-small, 16px)',
  heightForButtonAsMedium: 'var(--height-for-button-as-medium, 32px)',
  heightForButtonAs40: 'var(--height-for-button-as-40, 40px)',
  heightForButtonAs30: 'var(--height-for-button-as-30, 32px)',
  heightForButtonAs20: 'var(--height-for-button-as-20, 24px)',
  heightForButtonAs10: 'var(--height-for-button-as-10, 16px)',
  heightForInput: 'var(--height-for-input, 40px)',
  heightForInputAsSmall: 'var(--height-for-input-as-small, 32px)',
  shadowForInput: 'var(--shadow-for-input, none)',
  shadowForInputWhenFocused: 'var(--shadow-for-input-when-focused, inset 0 0 0 1px var(--color-primary))',
  shadowForInputWhenError: 'var(--shadow-for-input-when-error, inset 0 0 0 1px var(--color-error))',
  shadowForInputWhenWarning: 'var(--shadow-for-input-when-warning, inset 0 0 0 1px var(--color-warning))'
};
var designTokens$1 = designTokens;

/*
  This will transform a map of tokens names/values to
  a map of css var names/values

  Example input:
  {
    borderRadius4: '4px',
  }
  Example output:
  {
     '--border-radius-4': '4px',
  }
*/
function transformTokensToCssVarsValues(tokens) {
  var _context;
  return _Object$fromEntries(_mapInstanceProperty(_context = _Object$entries(tokens)).call(_context, _ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [`--${kebabCase(key)}`, value];
  }));
}

/*
  This will transform a map of tokens names/values to
  a map of token names/css var definitions.
  Including default css value in the definition is optional (true by default)

  Example input:
  {
    borderRadius4: '4px',
  }
  Example output:
  {
    borderRadius4: 'var(--border-radius-4, 4px)',
  }
*/
function transformTokensToCssVarsReferences(tokens) {
  var _context2;
  let _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      includeDefaultValue: true
    },
    includeDefaultValue = _ref3.includeDefaultValue;
  return _Object$fromEntries(_mapInstanceProperty(_context2 = _Object$entries(tokens)).call(_context2, _ref4 => {
    let _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return [key, `var(--${kebabCase(key)}${includeDefaultValue ? ', ' + value : ''})`];
  }));
}

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const allThemesNames = _Object$keys(themes);
// used to cover SSR builds (for instance in Gatsby)
const isBrowser = typeof window !== 'undefined';
const defaultParentSelector = () => isBrowser ? document.querySelector(':root') : null;
const applyTheme = _ref => {
  var _context;
  let newTheme = _ref.newTheme,
    _ref$parentSelector = _ref.parentSelector,
    parentSelector = _ref$parentSelector === void 0 ? defaultParentSelector : _ref$parentSelector,
    themeOverrides = _ref.themeOverrides;
  const target = parentSelector();

  // With no target we can't change themes
  if (!target) return;
  const validTheme = _includesInstanceProperty(allThemesNames).call(allThemesNames, newTheme || '') ? newTheme : 'default';
  if (newTheme && newTheme !== validTheme) {
    console.warn(`ThemeProvider: the specified theme '${newTheme}' is not supported.`);
  }
  const vars = transformTokensToCssVarsValues(merge({}, themes.default, themes[validTheme], isObject(themeOverrides) ? themeOverrides : {}));
  _forEachInstanceProperty(_context = _Object$entries(vars)).call(_context, _ref2 => {
    let _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    target.style.setProperty(key, value);
  });
  target.setAttribute('data-theme', validTheme);
};
const ThemeProvider = props => {
  const parentSelectorRef = useRef(props.parentSelector);
  const themeNameRef = useRef();
  const themeOverridesRef = useRef();
  useLayoutEffect(() => {
    // We want to make sure we don't really apply the change when the props
    // provided include a new object with the same theme overrides
    // (eg: users providing an inline object as prop to the ThemeProvider)
    if (themeNameRef.current !== props.theme || !isEqual(themeOverridesRef.current, props.themeOverrides)) {
      themeNameRef.current = props.theme;
      themeOverridesRef.current = props.themeOverrides;
      applyTheme({
        newTheme: props.theme,
        parentSelector: parentSelectorRef.current,
        themeOverrides: props.themeOverrides
      });
    }
  }, [props.theme, props.themeOverrides]);
  return null;
};
ThemeProvider.propTypes = {
  parentSelector: _pt.any,
  theme: _pt.string,
  themeOverrides: _pt.objectOf(_pt.string)
};
ThemeProvider.defaultProps = {
  parentSelector: defaultParentSelector,
  theme: 'default'
};
const useTheme = function () {
  let parentSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultParentSelector;
  const _useState = useState('default'),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  const parentSelectorRef = useRef(parentSelector);
  const mutationChangeCallback = useCallback(mutationList => {
    // We expect only a single element in the mutation list as we configured the
    // observer to only listen to `data-theme` changes.
    const _mutationList = _slicedToArray(mutationList, 1),
      mutationEvent = _mutationList[0];
    setTheme(mutationEvent.target.dataset.theme);
  }, []);
  useMutationObserver(parentSelector(), mutationChangeCallback, {
    attributes: true,
    attributeFilter: ['data-theme']
  });

  // TODO - make sure old and new theme return same value as new defaultThemeValue
  // At least for the remaining places that we still use this function
  const themedValue = useCallback((_defaultThemeValue, newThemeValue) => newThemeValue, []);

  // If we use 'useLayoutEffect' here, we would be trying to read the
  // data attribute before it gets set from the effect in the ThemeProvider
  useEffect(() => {
    // We need to read the current theme after the provider is rendered
    // to have the actual selected theme (calculated client-side) in the
    // hook local state
    const nextTheme = parentSelectorRef.current()?.dataset.theme;
    if (nextTheme) {
      setTheme(nextTheme);
    }
  }, []);
  return {
    theme,
    themedValue,
    isNewTheme: false,
    isRecolouringTheme: true
  };
};
const withThemeContext = WrappedComponent => {
  // eslint-disable-next-line react/display-name
  return props => {
    const themeUtilties = useTheme();
    return jsx(WrappedComponent, _objectSpread(_objectSpread({}, props), themeUtilties));
  };
};

/* eslint-disable @typescript-eslint/no-unused-vars */
const iconSizes = {
  small: 12,
  medium: 16,
  big: 24,
  '10': 12,
  '20': 16,
  '30': 20,
  '40': 24
};
const getSizeDimensions = size => {
  switch (size) {
    case 'scale':
      return {
        width: '100%',
        height: 'auto'
      };
    case 'small':
    case 'medium':
    case 'big':
    case '10':
    case '20':
    case '30':
    case '40':
      return {
        width: `${iconSizes[size]}px`,
        height: `${iconSizes[size]}px`
      };
    default:
      return {
        width: `${iconSizes['40']}px`,
        height: `${iconSizes['40']}px`
      };
  }
};
const getSizeStyle = size => {
  const dimensions = getSizeDimensions(size);
  switch (size) {
    case 'scale':
      return `
        &:not(:root) {
          width: ${dimensions.width};
          height: ${dimensions.height};
        }
      `;
    default:
      return `
        width: ${dimensions.width};
        height: ${dimensions.height};
      `;
  }
};
const getColor = color => {
  if (!color) return 'inherit';
  let iconColor;
  switch (color) {
    case 'solid':
      iconColor = designTokens$1.colorSolid;
      break;
    case 'neutral60':
      iconColor = designTokens$1.colorNeutral60;
      break;
    case 'surface':
      iconColor = designTokens$1.colorSurface;
      break;
    case 'info':
      iconColor = designTokens$1.colorInfo;
      break;
    case 'primary':
      iconColor = designTokens$1.colorPrimary;
      break;
    case 'primary40':
      iconColor = designTokens$1.colorPrimary40;
      break;
    case 'warning':
      iconColor = designTokens$1.colorWarning;
      break;
    case 'error':
      iconColor = designTokens$1.colorError;
      break;
    case 'success':
      iconColor = designTokens$1.colorSuccess;
      break;
  }
  if (!iconColor) {
    return 'inherit';
  }
  return iconColor;
};
const getIconStyles = props => /*#__PURE__*/css("*:not([fill='none']){fill:", getColor(props.color), ";}&,image{", getSizeStyle(props.size), ";}flex-shrink:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:getIconStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb24tdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEd1RCIsImZpbGUiOiJpY29uLXV0aWxzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50LWRpc2FibGUgQHR5cGVzY3JpcHQtZXNsaW50L25vLXVudXNlZC12YXJzICovXG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgZGVzaWduVG9rZW5zIGZyb20gJy4vZGVzaWduLXRva2Vucyc7XG5cbmV4cG9ydCB0eXBlIFRJY29uUHJvcHMgPSB7XG4gIGNvbG9yPzpcbiAgICB8ICdzb2xpZCdcbiAgICB8ICduZXV0cmFsNjAnXG4gICAgfCAnc3VyZmFjZSdcbiAgICB8ICdpbmZvJ1xuICAgIHwgJ3ByaW1hcnknXG4gICAgfCAncHJpbWFyeTQwJ1xuICAgIHwgJ3dhcm5pbmcnXG4gICAgfCAnZXJyb3InXG4gICAgfCAnc3VjY2Vzcyc7XG4gIC8qKlxuICAgKiBUaGUgc2l6ZSBvZiB0aGUgaWNvbi4gJ3NtYWxsJywgJ21lZGl1bScsICdiaWcnIGhhdmUgYmVlbiBkZXByZWNhdGVkIGluIGZhdm9yIG9mICcxMCcsICcyMCcsICczMCcsICc0MCcuXG4gICAqL1xuICBzaXplPzogJ3NtYWxsJyB8ICdtZWRpdW0nIHwgJ2JpZycgfCAnc2NhbGUnIHwgJzEwJyB8ICcyMCcgfCAnMzAnIHwgJzQwJztcbn07XG5leHBvcnQgdHlwZSBUU1ZHUHJvcHMgPSBUSWNvblByb3BzICYgeyBjbGFzc05hbWU6IHN0cmluZyB9O1xuXG5jb25zdCBpY29uU2l6ZXMgPSB7XG4gIHNtYWxsOiAxMixcbiAgbWVkaXVtOiAxNixcbiAgYmlnOiAyNCxcbiAgJzEwJzogMTIsXG4gICcyMCc6IDE2LFxuICAnMzAnOiAyMCxcbiAgJzQwJzogMjQsXG59IGFzIGNvbnN0O1xuY29uc3QgZ2V0U2l6ZURpbWVuc2lvbnMgPSAoc2l6ZTogVEljb25Qcm9wc1snc2l6ZSddKSA9PiB7XG4gIHN3aXRjaCAoc2l6ZSkge1xuICAgIGNhc2UgJ3NjYWxlJzpcbiAgICAgIHJldHVybiB7IHdpZHRoOiAnMTAwJScsIGhlaWdodDogJ2F1dG8nIH07XG4gICAgY2FzZSAnc21hbGwnOlxuICAgIGNhc2UgJ21lZGl1bSc6XG4gICAgY2FzZSAnYmlnJzpcbiAgICBjYXNlICcxMCc6XG4gICAgY2FzZSAnMjAnOlxuICAgIGNhc2UgJzMwJzpcbiAgICBjYXNlICc0MCc6XG4gICAgICByZXR1cm4geyB3aWR0aDogYCR7aWNvblNpemVzW3NpemVdfXB4YCwgaGVpZ2h0OiBgJHtpY29uU2l6ZXNbc2l6ZV19cHhgIH07XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiB7IHdpZHRoOiBgJHtpY29uU2l6ZXNbJzQwJ119cHhgLCBoZWlnaHQ6IGAke2ljb25TaXplc1snNDAnXX1weGAgfTtcbiAgfVxufTtcbmNvbnN0IGdldFNpemVTdHlsZSA9IChzaXplOiBUSWNvblByb3BzWydzaXplJ10pID0+IHtcbiAgY29uc3QgZGltZW5zaW9ucyA9IGdldFNpemVEaW1lbnNpb25zKHNpemUpO1xuICBzd2l0Y2ggKHNpemUpIHtcbiAgICBjYXNlICdzY2FsZSc6XG4gICAgICByZXR1cm4gYFxuICAgICAgICAmOm5vdCg6cm9vdCkge1xuICAgICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICAgIGhlaWdodDogJHtkaW1lbnNpb25zLmhlaWdodH07XG4gICAgICAgIH1cbiAgICAgIGA7XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiBgXG4gICAgICAgIHdpZHRoOiAke2RpbWVuc2lvbnMud2lkdGh9O1xuICAgICAgICBoZWlnaHQ6ICR7ZGltZW5zaW9ucy5oZWlnaHR9O1xuICAgICAgYDtcbiAgfVxufTtcblxuY29uc3QgZ2V0Q29sb3IgPSAoY29sb3I6IFRJY29uUHJvcHNbJ2NvbG9yJ10pID0+IHtcbiAgaWYgKCFjb2xvcikgcmV0dXJuICdpbmhlcml0JztcblxuICBsZXQgaWNvbkNvbG9yO1xuICBzd2l0Y2ggKGNvbG9yKSB7XG4gICAgY2FzZSAnc29saWQnOlxuICAgICAgaWNvbkNvbG9yID0gZGVzaWduVG9rZW5zLmNvbG9yU29saWQ7XG4gICAgICBicmVhaztcbiAgICBjYXNlICduZXV0cmFsNjAnOlxuICAgICAgaWNvbkNvbG9yID0gZGVzaWduVG9rZW5zLmNvbG9yTmV1dHJhbDYwO1xuICAgICAgYnJlYWs7XG4gICAgY2FzZSAnc3VyZmFjZSc6XG4gICAgICBpY29uQ29sb3IgPSBkZXNpZ25Ub2tlbnMuY29sb3JTdXJmYWNlO1xuICAgICAgYnJlYWs7XG4gICAgY2FzZSAnaW5mbyc6XG4gICAgICBpY29uQ29sb3IgPSBkZXNpZ25Ub2tlbnMuY29sb3JJbmZvO1xuICAgICAgYnJlYWs7XG4gICAgY2FzZSAncHJpbWFyeSc6XG4gICAgICBpY29uQ29sb3IgPSBkZXNpZ25Ub2tlbnMuY29sb3JQcmltYXJ5O1xuICAgICAgYnJlYWs7XG4gICAgY2FzZSAncHJpbWFyeTQwJzpcbiAgICAgIGljb25Db2xvciA9IGRlc2lnblRva2Vucy5jb2xvclByaW1hcnk0MDtcbiAgICAgIGJyZWFrO1xuICAgIGNhc2UgJ3dhcm5pbmcnOlxuICAgICAgaWNvbkNvbG9yID0gZGVzaWduVG9rZW5zLmNvbG9yV2FybmluZztcbiAgICAgIGJyZWFrO1xuICAgIGNhc2UgJ2Vycm9yJzpcbiAgICAgIGljb25Db2xvciA9IGRlc2lnblRva2Vucy5jb2xvckVycm9yO1xuICAgICAgYnJlYWs7XG4gICAgY2FzZSAnc3VjY2Vzcyc6XG4gICAgICBpY29uQ29sb3IgPSBkZXNpZ25Ub2tlbnMuY29sb3JTdWNjZXNzO1xuICAgICAgYnJlYWs7XG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgaWYgKCFpY29uQ29sb3IpIHtcbiAgICByZXR1cm4gJ2luaGVyaXQnO1xuICB9XG5cbiAgcmV0dXJuIGljb25Db2xvcjtcbn07XG5cbmV4cG9ydCBjb25zdCBnZXRJY29uU3R5bGVzID0gKHByb3BzOiBUSWNvblByb3BzKSA9PiBjc3NgXG4gICo6bm90KFtmaWxsPSdub25lJ10pIHtcbiAgICBmaWxsOiAke2dldENvbG9yKHByb3BzLmNvbG9yKX07XG4gIH1cbiAgJixcbiAgaW1hZ2Uge1xuICAgICR7Z2V0U2l6ZVN0eWxlKHByb3BzLnNpemUpfTtcbiAgfVxuICBmbGV4LXNocmluazogMDtcbmA7XG4iXX0= */");

// NOTE: This string will be replaced on build time with the package version.
var version = "19.20.1";

export { ThemeProvider, designTokens$1 as customProperties, designTokens$1 as designTokens, getIconStyles, themes, transformTokensToCssVarsReferences, transformTokensToCssVarsValues, useTheme, version, withThemeContext };
